export const magnetIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M5.75.575h-3a1 1 0 0 0-1 1v3h5v-3a1 1 0 0 0-1-1zm7 1v3h5v-3a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1zm0 10a3 3 0 0 1-6 0v-5h-5v5a8 8 0 0 0 16 0v-5h-5z"/></svg>`,
  name: 'magnet',
};
